import { render, staticRenderFns } from "./SiteMetadataV4.vue?vue&type=template&id=0a04410e&scoped=true"
import script from "./SiteMetadataV4.vue?vue&type=script&lang=js"
export * from "./SiteMetadataV4.vue?vue&type=script&lang=js"
import style0 from "./SiteMetadataV4.vue?vue&type=style&index=0&id=0a04410e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a04410e",
  null
  
)

export default component.exports